<template>
    <div style="display: inline-block; width: 100%">
        <div
            :class="['input-group',{ 'icon-valid': valid }, { 'icon-error': error }]"
            v-if="exibirInputMask || maskPersonalizada.mask"
        >
            <input
                :name="name"
                v-bind="$attrs"
                :value="value"
                :class="getInputClass"
                :type="type"
                :placeholder="placeholder"
                @input="handleInput"
                v-mask="maskPreparada"
                :masked="false"
                :readonly="readonly"
            />
            <transition name="error-message">
                <span v-if="errorMessage" class="error-message">{{ errorMessage }}</span>
               
            </transition>
        </div>
        <div
            :class="['input-group',{ 'icon-valid': valid }, { 'icon-error': error }]"
            v-if="!exibirInputMask && !maskPersonalizada.mask"
        >
            <input
                :name="name"
                v-bind="$attrs"
                :value="value"
                :class="getInputClass"
                :type="type"
                :placeholder="placeholder"
                @input="handleInput"
                :readonly="readonly"
                v-on:keyup.enter="apertouEnter()"
            />
            <transition name="error-message">
                <span v-if="errorMessage" class="error-message">{{ errorMessage }}</span>
            </transition>
        </div>
    </div>
</template>

<script>
import lodash from "lodash";
// Local Directive
import {mask} from 'vue-the-mask'


export default {
    name: "BaseInput",
    inheritAttrs: false,
    directives: {mask},
    props: {
        debounceTime: {
            type: Number,
            default: 0
        },
        error: {
            type: Boolean,
            default: false
        },
        errorMessage: {
            type: String | Boolean,
            default: ""
        },
        parse: {
            type: Function,
            default: value => value
        },
        valid: {
            type: Boolean,
            default: false
        },
        value: {
            type: String | Number,
            default: null
        },
        type: {
            type: String,
            default: "text"
        },
        readonly: {
            type: Boolean,
            default: false
        },
        name: {
            type: String,
            default: ""
        },
        placeholder: {
            type: String,
            default: ""
        },
        stringMask: {
            type: Object | String | Boolean,
            default: false
        },
        maskPersonalizada: {
            type: Object | Boolean,
            default: false
        },
        noBorder: {
            type: String,
            default: ""
        },
        inputClass:{
            type: String,
            default: ''
        },
        regex: {
            type: Object | Boolean,
            default: false
        },
        clickEnter: {
            type: Function,
            default: () => {}
        }
    },
    data() {
        return {
            localValue: null
        };
    },
    computed: {
        handleInput() {
            return lodash.debounce(event => {
                this.$emit("input", this.parse(event.target.value));               
                if (this.regex) {
                    let validarRegex = this.regex;
                    let isValidRegex = validarRegex.test(event.target.value);
                    this.$emit("inputValidado", isValidRegex);
                }
            }, this.debounceTime);
        },      
        getInputClass() {
            let classes = ["base-input"];
            if(this.inputClass) classes.push(this.inputClass);
            if (this.noBorder == "left") classes.push("no-border-left");
            if (this.noBorder == "right") classes.push("no-border-right");
            if (this.valid) classes.push("valid");
            if (this.error) classes.push("error");
            return classes;
        },
        maskPreparada(){
            if(this.name == 'label_cupom')
            console.log(this.maskPersonalizada)

            let mascaras = this.stringMask ? this.stringMask : this.maskPersonalizada 
            let mascaraPreparada = []
            if(typeof mascaras == 'object' &&  !this.maskPersonalizada){
                    mascaras.forEach(function(mascara, index) {
                        mascaraPreparada.push(mascara)
                    });
            }else if(!this.maskPersonalizada){                 
                mascaraPreparada.push(mascaras)
            }
            
            let returnMask;
            if(mascaraPreparada) returnMask = mascaraPreparada
            if(this.maskPersonalizada.mask) returnMask = this.maskPersonalizada 
            return returnMask
        },
        exibirInputMask(){
            let exibir = this.stringMask.length > 0
            return exibir
        }       
    },
    methods:{
            apertouEnter(event){
             if (typeof this.clickEnter === "function") {
                this.clickEnter(event, this.nomeArea);
            }            
        }
    },
    watch: {
        value(newValue) {
            this.localValue = this.localValue;
        }
    }
};
</script>

<style lang="scss" scoped>
@font-face {
    font-family: "Material Icons";
    font-style: normal;
    font-weight: 400;
    src: url("/src/assets/fonts/Material-Icons.woff2") format("woff2"),
        local("Arial");
    font-display: swap;
}

$standard-easing: cubic-bezier(0.4, 0, 0.2, 1);
$decelerate-easing: cubic-bezier(0, 0, 0.2, 1);
$accelerate-easing: cubic-bezier(0.4, 0, 1, 1);

.input-group {
    position: relative;
    width: 100%;
}
// .icon-valid:after {
//     content: "\E876";
//     display: block;
//     position: absolute;
//     font-family: "Material Icons";
//     color: #56bd5b;
//     font-size: 24px;
//     top: 7px;
//     right: 8px;
// }

// .icon-error:after {
//     content: "\E001";
//     position: absolute;
//     font-family: "Material Icons";
//     color: #e34c4c;
//     font-size: 24px;
//     top: 7px;
//     right: 8px;
// }

.base-input {
    border: 1px solid #ddd;
    border-radius: 4px;
    height: 40px;
    width: 99%;
    outline: none;
    padding: 2px 8px;
    box-sizing: border-box;
    color: #30455c;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5em;
    transition: background-color 0.2s, border-color 0.2s, color 0.2s;
    position: relative;
    font-family: "Lato", sans-serif !important;

    &:focus {
        border-color: #004990;
    }
    &:disabled {
        background-color: #d0ddea;
        border-color: #004990;
        pointer-events: none;
    }
    &::placeholder {
        color: #7c92ab;
    }
}

.valid {
    border-color: #56bd5b !important;
}

.error {
    border-color: #e34c4c !important;
}

.error-message {
    font-size: 12px;
    font-weight: 400;
    line-height: 2em;
    float: left;
    color: #e34c4c;
}

.error-message-enter-active,
.error-message-leave-active {
    transition: transform 0.2s $decelerate-easing,
        opacity 0.1s $decelerate-easing;
}
.error-message-enter,
.error-message-leave-to {
    transform: translate(0, -100%);
    opacity: 0;
    transition: transform 0.2s $accelerate-easing,
        opacity 0.1s $accelerate-easing;
}

.error-input-indication,
.valid-input-indication {
    float: right;
    position: absolute;
    margin-top: 8px;
    right: 40px;
}

.error-input-indication {
    color: #e34c4c;
}

.valid-input-indication {
    color: #56bd5b;
}

.no-border-left {
    border-radius: 0 4px 4px 0;
}
.no-border-right {
    border-radius: 4px 0 0 4px;
}
 .big-input{
    font-size: 2em;
    letter-spacing: .5em;
    padding: 1em;
    text-align: center;
}
</style>